module.exports = __webpack_public_path__ + "media/financial_aid_information/620x566-08fef56a.png";